import React from 'react'
import {connect} from 'react-redux'
import {withStyles} from '@material-ui/core/styles'
import classNames from 'classnames';
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableFooter from '@material-ui/core/TableFooter'
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FormLabel from '@material-ui/core/FormLabel';
import OfflinePinIcon from '@material-ui/icons/OfflinePin'
import { lighten } from '@material-ui/core/styles/colorManipulator';
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import TextField from '@material-ui/core/TextField'
import SearchIcon from '@material-ui/icons/Search'
import Grid from '@material-ui/core/Grid'
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import * as actions from '../reducers/list'
import Pagination from '../../../../../uis/pagination'
import NoData from '../../../../../uis/noData'
import DateFormat from '../../../../../util/dateFormat'


const styles = theme => ({
    paper: {
        marginTop: theme.spacing.unit * 3,
    },
    root: {
      width: '100%',
      marginTop: theme.spacing.unit * 3,
    },
    table: {
      minWidth: 1020,
    },
    tableWrapper: {
      overflowX: 'auto',
    },
    contentCell: {
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        textDecoration: 'underline',
        cursor: 'pointer'
    },
    statusSelect: {
        margin: theme.spacing.unit,
        minWidth: 150,
    },
    raidoGroup: {
        flexDirection: 'row'
    }
});

const columnTitle = [
    {id: 'createTime',numeric: false,disablePadding: false,label: '时间'},
    {id: 'title', numeric: false,disablePadding: false,label: '标题'},
    {id: 'content',numeric: false,disablePadding: false,label: '内容'},
    {id: 'status',numeric: false,disablePadding: false,label: '状态'}
]

class EnhancedTableHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event,property);
    };
    render() {
        const { onSelectAllClick,order,orderBy,numSelected,rowCount,permissionMap } = this.props
        return (
            <TableHead>
                <TableRow>
                    <TableCell padding="checkbox">
                        <Checkbox 
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={numSelected === rowCount}
                            onChange={onSelectAllClick}
                        />
                    </TableCell>
                    {columnTitle.map(column => {
                        return (
                                <TableCell
                                    key={column.id}
                                    numeric={column.numeric}
                                    padding={column.disablePadding ? 'none' : 'default'}
                                    sortDirection={orderBy === column.id ? order : false}
                                >
                                <Tooltip title="排序" placement={column.numeric ? 'bottom-end' : 'bottom-start'} enterDelay={300}>
                                    <TableSortLabel active={orderBy === column.id} direction={order} onClick={this.createSortHandler(column.id)}>
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        )
                    },this)}
                    {permissionMap['消息管理_删除'] && <TableCell>操作</TableCell>}
                </TableRow>
            </TableHead>
        )
    }
} 
EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
}
const toolbarStyles = theme => ({
    root: {
      paddingRight: theme.spacing.unit,
    },
    highlight:
      theme.palette.type === 'light'
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
          }
        : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.dark,
          },
    spacer: {
      flex: '1 1 100%',
    },
    actions: {
      color: theme.palette.text.secondary,
    },
    title: {
      flex: '0 0 auto',
    },
    toolbarActions: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    }
  });
  
let EnhancedTableToolbar = props => {
    const { numSelected, classes,onDeleteAll,onSetRead,permissionMap } = props;
    return (
        <Toolbar
            className={classNames(classes.root, {
            [classes.highlight]: numSelected > 0,
            })}
        >
            <div className={classes.title}>
            {numSelected > 0 ? (
                <Typography color="inherit" variant="subheading">
                {numSelected} selected
                </Typography>
            ) : (
                <Typography variant="title" id="tableTitle">
                    消息列表
                </Typography>
            )}
            </div>
            <div className={classes.spacer} />
            <div className={classes.actions}>
            {numSelected > 0 && (
                <div className={classes.toolbarActions}>
                    <Tooltip title="标记为已读">
                        <IconButton aria-label="read" onClick={onSetRead}>
                            <OfflinePinIcon />
                        </IconButton>
                    </Tooltip>
                    {permissionMap['消息管理_删除'] && <Tooltip title="Delete">
                        <IconButton aria-label="Delete" onClick={onDeleteAll}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>}
                </div>
            )}
            </div>
        </Toolbar>
    );
};
  
EnhancedTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
};
  
EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

class News extends React.Component {
    componentDidMount() {
        const {dispatch} = this.props
        dispatch(actions.getList())
    }
    onPageClick = (index) => {
        const {dispatch,page} = this.props
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, index}
        })
        dispatch(actions.getList())
    }
    handleRequestSort = (event,property) => {
        const {dispatch,orderBy,order,list} = this.props
        const curOrderBy = property;
        let curOrder = 'desc'
        if (orderBy === property && order === 'desc') {
            curOrder = 'asc'
        }
        const curList = 
            order === 'asc' 
            ? list.sort((a,b) => (b[orderBy] < a[orderBy] ? -1 : 1))
            : list.sort((a,b) => (a[orderBy] < b[orderBy] ? -1 : 1))
        dispatch({type:actions.CHANGE_SORT,key: 'list',value: curList})
        dispatch({type:actions.CHANGE_SORT,key: 'order',value: curOrder})
        dispatch({type:actions.CHANGE_SORT,key: 'orderBy',value: curOrderBy})
    }
    handleSelectAllClick = (event, checked) => {
        const {dispatch,list} = this.props
        if (checked) {
            dispatch({type: actions.CHANGE_SELECTED,value: list.map(row => row.id)})
          return;
        }
        dispatch({type: actions.CHANGE_SELECTED,value: []})
    };
    handleClick = (event,id) => {
        const {dispatch,selected} = this.props
        const selectedIndex = selected.indexOf(id)
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected,id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length -1) {
            newSelected = newSelected.concat(selected.slice(0,-1))
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0,selectedIndex),
                selected.slice(selectedIndex + 1)
            )
        }
        dispatch({type: actions.CHANGE_SELECTED,value:newSelected})
    }
    isSelected = id => this.props.selected.indexOf(id) !== -1;
    handleSearch = () => {
        const {dispatch,page} = this.props
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, index: 0}
        });
        dispatch(actions.getList())
    }
    changQuery = (value) => {
        const {dispatch,page} = this.props
        dispatch({type: actions.CHANGE_QUERY, value});
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, index: 0}
        });
        dispatch(actions.getList())
    }
    render() {
        const {classes,dispatch,list,page,total,order,orderBy,selected,search,status,showModal,permissionMap} = this.props
        return (
            <div>
                <Grid container spacing={8} alignItems="baseline" style={{justifyContent: 'space-between'}}>
                    <Grid item>
                        <FormControl component="fieldset" className={classes.formControl}>
                            <FormLabel component="legend">消息类型</FormLabel>
                            <RadioGroup
                                aria-label="消息类型"
                                name="newsType"
                                className={classes.raidoGroup}
                                value={status}
                                onChange={(e) => this.changQuery(e.target.value)}
                            >
                                <FormControlLabel value="0" control={<Radio />} label="全部" />
                                <FormControlLabel value="已读" control={<Radio />} label="已读" />
                                <FormControlLabel value="未读" control={<Radio />} label="未读" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item>
                        <TextField value={search.value} placeholder="按标题搜索" onChange={(e) => dispatch({type: actions.CHANGE_SEARCH_VALUE, value: e.target.value})} />
                        <IconButton onClick={() => this.handleSearch()}><SearchIcon /></IconButton>
                    </Grid>
                </Grid>
                <Paper className={classes.paper}>
                    <EnhancedTableToolbar 
                        numSelected={selected.length} 
                        onDeleteAll={() => dispatch({type: actions.SHOW_MODAL,key: 'delete',title: '批量',id: selected.map(item => item).join(',')})} 
                        onSetRead={() => dispatch(actions.setRead())}
                        permissionMap={permissionMap}
                    />
                    <div className={classes.tableWrapper}>
                        {list.length === 0 && <NoData />}
                        {list.length > 0 &&<Table className={classes.table} aria-labelledby="tableTitle">
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={this.handleSelectAllClick}
                                onRequestSort={this.handleRequestSort}
                                rowCount={list.length}
                                permissionMap={permissionMap}
                            />
                            <TableBody>
                                {list.map((row,index) => {
                                    const isSelected = this.isSelected(row.id)
                                    return (
                                        <TableRow
                                            hover
                                            onClick={e => this.handleClick(e,row.id)}
                                            role="checkbox"
                                            aria-checked={isSelected}
                                            tabIndex={-1}
                                            key={row.id}
                                            selected={isSelected}
                                            style={{opacity: row.status === '已读' ? '0.5' : '1'}}
                                        >
                                            <TableCell padding="checkbox">
                                                <Checkbox checked={isSelected} />
                                            </TableCell>
                                            <TableCell>{DateFormat(new Date(row.createTime),'yyyy-MM-dd HH:mm')}</TableCell>
                                            <TableCell>{row.title}</TableCell>
                                            <TableCell className={classes.contentCell} onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'detail',content: row.content})} dangerouslySetInnerHTML={{__html: row.content}} />
                                            <TableCell>{row.status}</TableCell>
                                            {permissionMap['消息管理_删除'] && <TableCell>
                                                <IconButton color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'delete',id: row.id})}><DeleteIcon /></IconButton>
                                            </TableCell>}
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                            <TableFooter>
                                <Pagination 
                                    total={total}
                                    {...page}
                                    onPageClick={this.onPageClick}
                                />
                            </TableFooter>
                        </Table>}
                    </div>
                </Paper>
                <Dialog
                    open={showModal.delete}
                    onClose={() => dispatch({type: actions.HIDE_MODAL})}
                    fullWidth
                >
                    <DialogContent>
                        确定{showModal.title}删除吗？
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                        <Button variant="outlined" color="primary" onClick={() => dispatch(actions.remove(showModal.id))}>确定</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={showModal.detail}
                    onClose={() => dispatch({type: actions.HIDE_MODAL})}
                    fullWidth
                    onEntered={() => dispatch(actions.setRead())}
                >
                    <DialogTitle>消息详情</DialogTitle>
                    <DialogContent>
                        <div dangerouslySetInnerHTML={{__html: showModal.content}}></div>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>确定</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.news,
        permissionMap: state.auth.user.permissionMap
    }
}
export default connect(mapStateToProps)(withStyles(styles)(News))


// WEBPACK FOOTER //
// ./src/pages/home/routes/news/components/list.js